import { Component, Input, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UiKitModule } from "@app/ui-kit.module";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { UserService } from "@domain/user/user.service";
import { BusinessScope } from "@lib/constants/business-scope";
import { FloorplanMenuButtonComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-button/floorplan-menu-button.component";
import { FloorplanMenuType, LocalizeFloorplanMenuTypePipe } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-type";
import { FloorplanMenuItemComponent } from "@project/floorplanner/floorplan-menu/floorplan-menu-item.component";

@Component({
  selector: "app-floorplan-menu",
  templateUrl: "./floorplan-menu.component.html",
  styleUrl: "./floorplan-menu.component.scss",
  imports: [UiKitModule, FloorplanMenuButtonComponent, FloorplanMenuItemComponent, LocalizeFloorplanMenuTypePipe],
  standalone: true,
})
export class FloorplanMenuComponent implements OnInit {
  readonly BusinessScope = BusinessScope;
  private activatedRoute = inject(ActivatedRoute);
  private userService = inject(UserService);

  @Input({ required: true }) activeFloorplan!: Floorplan;

  protected readonly FloorplanMenuType = FloorplanMenuType;
  protected expanded: boolean = false;
  protected selectedMenu?: FloorplanMenuType;

  protected readonly textHideMenu: string = $localize`:@@floorplan.menu.hideMenu:Menü einklappen`;
  protected readonly textShowMenu: string = $localize`:@@floorplan.menu.showMenu:Menü ausklappen`;

  protected userScope!: BusinessScope;

  constructor() {
    this.userService.user$.subscribe((user) => {
      this.userScope = user.scope!;
    });
  }

  ngOnInit(): void {
    const selectedGroup = this.activatedRoute.snapshot.queryParamMap.get("selectedGroup");
    if (!selectedGroup) {
      return;
    }
    const selectedMenu = Number(selectedGroup) as FloorplanMenuType;
    if (Number.isNaN(selectedMenu)) {
      return;
    }
    this.selectedMenu = selectedMenu;
  }

  close() {
    this.selectedMenu = undefined;
  }

  open(selectedItem: FloorplanMenuType) {
    this.selectedMenu = selectedItem;
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
